import React from 'react';

import Layout from '@src/layouts';
import SEO from '@commons/SEO';
import { Header } from '@commons/header/Header';

import { experience } from '@pages-impl/spe-cloud/our-experience/payload';
import { SPENEScrollWrapper } from '@pages-impl/spe-ne/spe-ne-scroll-wrapper';
import {
  OpenStackSection,
  OurExperienceSection,
  CloudNativeSection,
  PublicCloudSection,
  KubernetesOpenshiftSection,
} from '@pages-impl/spe-cloud';

import featuredImage from '@images/header-images/featured_image_og_codilime_SPE_cloud.jpg';

const scrollPayload = [{ title: 'Our experience in a nutshell', sectionId: 'spe-cloud-experience' }, ...experience];

export default function SPECloud(props) {
  return (
    <Layout {...props}>
      <SEO
        title="Cloud Software Development Services Company - CodiLime"
        description="CodiLime specializes in building and integrating cloud solutions across private, public and hybrid cloud environments. See how we help."
        featuredImage={featuredImage}
      />
      <Header
        title="Cloud"
        aboveTitle="Software product engineering"
        descriptionText="Building your software for the cloud"
        id="cloud_header"
        src="spe_cloud_header.jpg"
        srcSmall="spe_cloud_header_small.jpg"
      />
      <SPENEScrollWrapper payload={scrollPayload}>
        <OurExperienceSection />
        <OpenStackSection />
        <KubernetesOpenshiftSection />
        <CloudNativeSection />
        <PublicCloudSection />
      </SPENEScrollWrapper>
    </Layout>
  );
}
